import React from 'react';
import { Breadcrumb, Panel } from 'rsuite';
import PageHeader from '@/components/PageHeader';
import PointAccountList from './point-account-list';

const Page = () => {
  return (
    <Panel
      header={
        <PageHeader title="Point Accounts">
          <Breadcrumb>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
            <Breadcrumb.Item active>Point Accounts</Breadcrumb.Item>
          </Breadcrumb>
        </PageHeader>
      }
    >
      <PointAccountList />
    </Panel>
  );
};

export default Page;
